module.exports = __webpack_public_path__ + "img/location-plus-light.60319abd.svg";